import { memo } from 'react';

export const DividerBlock = memo(function DividerBlock() {
  return <hr className="my-4 h-px border-0 bg-border" />;
});
